module.exports = __webpack_public_path__ + "static/media/student-setting-comment01.db95740b.png";